//this is the reducer combiner
import {combineReducers} from 'redux';
import user from './userReducer';
import users from './usersReducer';
import collection from './collectionReducer';
import collections from './collectionsReducer';
import recipe from './recipeReducer';
import recipes from './recipesReducer';
import ajaxCallsInProgress from './ajaxStatusReducer';

const rootReducer = combineReducers({
	user,
	users,
	collection,
	collections,
	recipe,
	recipes,
	ajaxCallsInProgress
});

export default rootReducer;


/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/